

/// <reference path="CoreEntityUpdatedBy.ts" />

// Generated class Department_ManagedObject

class Department_ManagedObject extends CoreEntityUpdatedBy
{

    // Property: expectedTipPercentage
    set expectedTipPercentage(value:number) {
        this.setValueForKey(value, 'expectedTipPercentage');
    }
    get expectedTipPercentage():number {
        return this.valueForKey('expectedTipPercentage');
    }
    set expectedTipPercentagePrimitiveValue(value:number) {
        this.setPrimitiveValueForKey(value, 'expectedTipPercentage');
    }
    get expectedTipPercentagePrimitiveValue():number {
        return this.primitiveValueForKey('expectedTipPercentage');
    }

    // Property: name
    set name(value:string) {
        this.setValueForKey(value, 'name');
    }
    get name():string {
        return this.valueForKey('name');
    }
    set namePrimitiveValue(value:string) {
        this.setPrimitiveValueForKey(value, 'name');
    }
    get namePrimitiveValue():string {
        return this.primitiveValueForKey('name');
    }

    // Property: tipPoolPercentage
    set tipPoolPercentage(value:number) {
        this.setValueForKey(value, 'tipPoolPercentage');
    }
    get tipPoolPercentage():number {
        return this.valueForKey('tipPoolPercentage');
    }
    set tipPoolPercentagePrimitiveValue(value:number) {
        this.setPrimitiveValueForKey(value, 'tipPoolPercentage');
    }
    get tipPoolPercentagePrimitiveValue():number {
        return this.primitiveValueForKey('tipPoolPercentage');
    }

    // Relationship: lists
    protected _lists:MIOManagedObjectSet = null;
    get lists():MIOManagedObjectSet {
        return this.valueForKey('lists');
    }
    addListsObject(value:APPCC_List) {
        this._addObjectForKey(value, 'lists');
    }
    removeListsObject(value:APPCC_List) {
        this._removeObjectForKey(value, 'lists');
    }

    // Relationship: workers
    protected _workers:MIOManagedObjectSet = null;
    get workers():MIOManagedObjectSet {
        return this.valueForKey('workers');
    }
    addWorkersObject(value:Employee) {
        this._addObjectForKey(value, 'workers');
    }
    removeWorkersObject(value:Employee) {
        this._removeObjectForKey(value, 'workers');
    }
}
